export default class pegAppleSocialButton extends HTMLElement {
	static get observedAttributes() {
		return ['orientation'];
	}

	async connectedCallback() {
		await jPar.util.waitForChildNodes();
		this.abortController = new AbortController();
		this.#createMarkup();
		this.#getDynamicConf();

		this.shadowRoot.querySelector('a').addEventListener('click', (event) => {
			if (this.hasAttribute('disabled')) {
				event.preventDefault();
			}
		});
	}

	disconnectedCallback() {
		this.abortController?.abort();
	}

	#createMarkup() {
		const template = document.createElement('template');
		const shadowHtml = `<style>
					:host {
						overflow: hidden;
						display: block;
					}
					
					:host([disabled]) a {
						background-color: var(--COLOR_support_black_default); /* TODO 70% machen */
						opacity: .6;
						cursor: default;
					}
					
					:host a {
						position: relative;
						display: flex;
						justify-content: center;
						align-items: center;
						width: 100%;
						margin-top: 4px;
						height: 44px;
						color: var(--COLOR_support_white_default);
						border: 0;
						background-color: var(--COLOR_support_black_default);
						border-radius: var(--borderRadius_button);
						cursor: pointer;
						text-decoration: none;
					}
					
					::slotted([slot="icon"].wdk-icon) {
						margin-bottom: 2px;
						margin-right: 4px;
						fill: var(--COLOR_support_white_default) !important;
					}
					
					:host a span {
						font: var(--FONT_highlight_75);
					}
				</style>
				<a aria-label="Apple Login" role="button" href="#">
					<slot name="icon"></slot>
					<span class="text"><slot name="buttonText"></slot></span>
				</a>
			`;

		template.innerHTML = this.#sanitizeEvilHtml(shadowHtml);

		const clone = document.importNode(template.content, true);
		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
		}
	}

	attributeChangedCallback(name, oldVal, newVal) {
		if (name === 'orientation' && oldVal !== newVal) {
			this.#setHref(newVal);
		}
	}

	#setHref(orientation) {
		const searchParam = orientation !== undefined ? `&search=${orientation}` : ''; // just for Registration
		const appleDomain = 'https://appleid.apple.com/auth/authorize';
		const appleCallbackPart = this.getAttribute('special-callback') !== null ? this.getAttribute('special-callback') : 'appleCallback';
		const clientIdParam = '?client_id=' + dynamicConf.apple.clientId;
		const redirectUriParam = `&redirect_uri=${encodeURIComponent(dynamicConf.apple.callbackDomain)}%2F${appleCallbackPart}`;
		const staticParams = `&response_type=${encodeURIComponent('code id_token')}&response_mode=form_post&scope=email`;
		const action = this.getAttribute('orientation') !== null ? 'reg' : 'login';
		const stateParam = `&state=action%3D${action}%26oid%3D${this.getAttribute('oid')}${encodeURIComponent(searchParam)}`;
		const stateAttr = this.getAttribute('social-provider-state');
		const socialProviderState = stateAttr !== null && stateAttr !== '' ? encodeURIComponent(`&socialProviderState=${stateAttr}`) : '';
		const fullUrl = appleDomain + clientIdParam + redirectUriParam + staticParams + stateParam + socialProviderState;

		this.shadowRoot.querySelector('a').setAttribute('href', fullUrl);
	}

	#getDynamicConf() {
		if (typeof dynamicConf === 'object') {
			this.#setHref();
		} else {
			const scriptTag = document.createElement('script');
			scriptTag.setAttribute('src', '/common/dynamicconf');
			this.shadowRoot.appendChild(scriptTag);

			if (!scriptTag.onloadDone) {
				scriptTag.onloadDone = true;
				scriptTag.onload = () => {
					this.#setHref();
				};
			}
		}
	}

	#sanitizeEvilHtml(string) {
		// Das muss nochmal ein richtiger sanatizer werden
		return String(string).replace(
			/<script\b|\bonerror=|\bonload=|\bonmouseover=|\bonmouseout=|\bonpagehide=|\bonpageshow=|\bonmessage=|\bonhashchange=|\bonbeforeunload=|\bonpopstate=|\bonresize=|\bonunload=|\bonkeydown=|\bonkeyup=|\bonkeypress=|\bonfocus=|\bonblur=|\bonchange=|\bonsubmit=|\bonreset=|\bonselect=|\bondblclick=|\bondrag=|\bondragend=|\bondragenter=|\bondragleave=|\bondragover=|\bondragstart=|\bondrop=|\bonwheel=|\boncopy=|\boncut=|\bonpaste=|\bonanimationend=|\bonanimationiteration=|\bonanimationstart=|\bontransitionend=|\bontouchcancel=|\bontouchend=|\bontouchmove=|\bontouchstart=|\bonclick=/gi,
			'',
		);
	}
}
